export default __webpack_public_path__ + "static/media/growth.2bb89e1d.png";